// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e4878ccf","413":"734f59a6","453":"daa9e50a","636":"6b4741bd","704":"b30f83cf","807":"7c5fb805","883":"78237afd"}[chunkId] + ".chunk.js";
};